import { ShippingManifestSummary } from '@/types';

export type ManifestListStatus = 'active' | 'planned';

export const manifestListStatus = (
  eta?: string | null,
  now = Date.now(),
): ManifestListStatus =>
  eta && new Date(eta).getTime() > now ? 'planned' : 'active';

export const filterManifestRows = (
  rows: ShippingManifestSummary[],
  filters: { status?: string; dateFrom?: string; dateTo?: string },
  now = Date.now(),
) =>
  rows.filter((row) => {
    if (filters.status && manifestListStatus(row.eta, now) !== filters.status) {
      return false;
    }
    const eta = row.eta ? new Date(row.eta).getTime() : undefined;
    if (filters.dateFrom) {
      if (!eta || eta < new Date(filters.dateFrom).getTime()) return false;
    }
    if (filters.dateTo) {
      if (!eta || eta > new Date(filters.dateTo).getTime()) return false;
    }
    return true;
  });
